import { Icon, IconButton, Tooltip } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import Meter from "../../components/Meter";
import MetricsCard from "../../components/MetricsCard";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import { Reducers } from "../../Interfaces/Interfaces";
import { getAggregators } from "../../redux/actions/AggregatorAction";
import PrimaryTheme from "../../Themes/Primary";

export default function Aggregators() {
  const aggregators = useSelector((state: Reducers) => state.aggregators);
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);
  const dashboard = useSelector((state: any) => state.dashboard);
  // const dashboard: Dashboard = useSelector((state: Reducers) => state.dashboard);
  const target = useSelector((state: Reducers) => state.target);

  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [searchState, setSearchState] = React.useState("");
  const [value] = React.useState(
    target && target.targetPercentage ? target.targetPercentage : 0
  );

  let list = aggregators && aggregators.items;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getAggregators(paginationConfig));
  };

  const handleRefresh = () => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getAggregators(paginationConfig));
  };

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });

    dispatch(getAggregators(paginationConfig));

    return () => {
      dispatch({
        type: "AGGREGATORS",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, dispatch]);

  React.useEffect(() => {
    if (searchState.length >= 3) {
      filter.name = searchState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({ type: "LOADING", payload: true });
      dispatch(getAggregators(paginationConfig));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchState]);

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setSearchState("");

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    dispatch(getAggregators(paginationConfig));
  };

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      } else {
        handleRefresh();

        dispatch({
          type: "LOADING",
          payload: false,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          // overflow: "auto",
          backgroundColor: PrimaryTheme.white,
          minHeight: "100vh",
          height: "auto",
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
            // zIndex: 1000,
          }}
        >
          <div className="row mb-5">
            <div
              className="col-md-4 col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="first"
                title="Onboarded Aggregator"
                value={
                  dashboard?.totalAggregators
                    ? dashboard?.totalAggregators
                    : "0"
                }
                buttonTitle="+ Add Aggregator"
                // onMenuChange={(e: any) => handleChangeOnboarded(e.target.value)}
                hasMenu
                hasButton
                buttonColor={PrimaryTheme.success}
                buttonClick={() => history.push(`/aggregator/new`)}
              />
            </div>

            <div
              className="col-md-4 col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <Meter value={0} hasMenu title="Target" hasTransfer={0} />
            </div>

            <div
              className="col-md-4 col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <MetricsCard
                id="third"
                value={"0"}
                buttonColor={PrimaryTheme.primary}
                hasButton
                buttonTitle="View POS Aggregator"
                title="No of aggregators"
                buttonClick={() => history.push(`/pos`)}
              />
            </div>
          </div>
          <div className="row justify-content-center align-content-center">
            {/* <div className="col-md-12">
              <h1 style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                textTransform: "uppercase",
                fontSize: PrimaryTheme.fontSizes?.subtitle
              }}>Total Trade Partners</h1>

              <h3 className="mb-5" style={{
                fontFamily: PrimaryTheme.fonts?.MediumFont,
                textTransform: "uppercase",
                // fontSize: PrimaryTheme.fontSizes?.subtitle,
                color: PrimaryTheme.primary
              }}>{aggregators.total ? aggregators.total : '-'}</h3>
            </div> */}

            {/* <div className="col-md-5 text-right">
              <div className="row m-0 justify-content-end align-items-right">
                <i className="bi bi-plus-circle-fill pointer" style={{
                  color: PrimaryTheme.primary,
                  fontSize: 18
                }} onClick={() => history.push('/aggregator/create')}></i>
                <span className="ml-2 pointer" onClick={() => history.push('/aggregator/create')}>Add Aggregator</span>
              </div>
            </div> */}
          </div>

          <div className="row mb-5 m-0">
            <div className="col-md-12 p-0">
              <Filters
                name="Aggregators"
                hasSearch
                searchState={searchState}
                // isPOS
                handleSearch={(e: any) => setSearchState(e.target.value)}
                // onClick={(e: any) => setSearchState(e.target.value)}
                onClear={handleClear}
              />
            </div>
          </div>

          <div className="row" style={{ paddingBottom: "150px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr className="text-center">
                          <th>#</th>
                          {/* <th>Role</th> */}
                          <th>Full Name</th>
                          <th>Email</th>
                          <th>Phone Number</th>
                          {/* <th>State/Lga</th> */}
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr key={index} className="text-center">
                              <th scope="row">{getIndexSeed(index)}</th>
                              {/* <td>-</td> */}
                              <td>
                                {item.firstName} {item.lastName}
                              </td>
                              <td>{item.email}</td>
                              <td>{item.phoneNumber}</td>
                              {/* <td>
                                {item.state && item.state} {item.state && "/"}{" "}
                                {item.lga && item.lga}
                              </td> */}
                              {item.active && (
                                <td>
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.success,
                                    }}
                                  >
                                    check_all
                                  </Icon>
                                </td>
                              )}
                              {!item.active && (
                                <td>
                                  <Icon
                                    style={{
                                      color: PrimaryTheme.danger,
                                    }}
                                  >
                                    close
                                  </Icon>
                                </td>
                              )}
                              <td className="p-0">
                                <Tooltip title="View">
                                  <IconButton
                                    aria-label="View"
                                    onClick={() =>
                                      history.push(
                                        `/aggregators/details/${item.id}`
                                      )
                                    }
                                  >
                                    <Icon>visibility</Icon>
                                  </IconButton>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {aggregators.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={aggregators.total && aggregators.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
